module.exports = window.Urls;
